(() => {
  if (window.aspenPassPurchaseInitialized) return;
  window.aspenPassPurchaseInitialized = true;
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form[data-season-pass-purchase]');
    if (!form || !window.AGF?.addToCart) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (form.dataset.busy === 'true' || button.disabled || !form.reportValidity()) return;
    const fields = new FormData(form);
    const id = fields.get('id');
    if (!id) return;
    const properties = {};
    fields.forEach((value, key) => {
      const match = /^properties\[(.+)\]$/.exec(key);
      if (match) properties[match[1]] = value;
    });
    const error = form.querySelector('[data-pass-error]');
    error.hidden = true;
    form.dataset.busy = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      await window.AGF.addToCart([{ id, quantity: 1, properties }]);
    } catch (_) {
      error.hidden = false;
    } finally {
      delete form.dataset.busy;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
